import { onlineManager } from '@tanstack/react-query';
import onlineKitDetailsRepositoryOfflineAdapters from '../../../../modules/offline/offlineRequestAdapters/onlineKitDetails.repository.adapters';
import { onlineKitDetailsRepository } from './onlineKitDetails.repository';

const kitDetailsRepository = (isOfflineMode: boolean = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineKitDetailsRepositoryOfflineAdapters()
    : onlineKitDetailsRepository();

export default kitDetailsRepository;
